import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';

import { PortalService } from '../services/portal.service';
import { AuthService } from '../services/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    let headersConfig: any = {};

    if (request.url.includes('/sonft/file/minio/upload')) {
      return next.handle(request);
    }
    if (PortalService.Settings.portal_id) {
      headersConfig['Portal-Id'] = PortalService.Settings.portal_id;
    }
    if (AuthService.getAccessToken()) {
      headersConfig['X-Access-Token'] = AuthService.getAccessToken();
    }

    const req = request.clone({ setHeaders: headersConfig });
    return next.handle(req);
  }
}
